import request, { SuperAgentRequest, Response } from 'superagent'
import { LocalStorageWrapper } from '../LocalStorage/LocalStorageWrapper';

export const IS_PROD: boolean = process.env.NODE_ENV === "production" && window.location.hostname === 'app.quotemyorder.com'
const IS_TEST: boolean = process.env.NODE_ENV === "test" || window.location.hostname === 'test.app.quotemyorder.com'
const IS_DEV: boolean = process.env.NODE_ENV === "development"

const HOST = getHostname() // (window.location.hostname === 'app.quotemyorder.com' || window.location.hostname === "quotemyorder.web.app") ? 'https://quotemyorder.appspot.com/' : "http://localhost:5000/"

const WEBAPI_URL = HOST + "api"
export const IMAGES_URL = HOST + "img/"
export const RESET_PASSWORD_REDIRECT_URL = 'http://' + window.location.hostname

const maxRetryAttempts = 3
const retryBasePeriod = 1000 // in miliseconds

function getHostname() {
    if (IS_DEV)
        return "http://localhost:5000/"
    else
        if (IS_TEST)
            return "https://develop-dot-peaceful-berm-266823.appspot.com/"
        else
            if (IS_PROD)
                return "https://peaceful-berm-266823.appspot.com/"
            else
                throw Error("Unknown configuration.")
}

function callWebApi(call: SuperAgentRequest, successCallback: (body: any) => void, errorCallback: (err: any) => void, retry: boolean, attempt: number, querySpecificNumbOfAttempts: number) {
    call
        .end((err: any, res: Response) => {
            if (err) {
                if (retry && (querySpecificNumbOfAttempts !== undefined ? attempt <= querySpecificNumbOfAttempts : attempt <= maxRetryAttempts)) {
                    // Try to handle error internally and repeat call if possible
                    dealWithError(err, call, successCallback, errorCallback, attempt, querySpecificNumbOfAttempts)
                }
                else {
                    errorCallback(decodeError(err))
                }
            }
            else {
                sessionStorage.setItem('backendWorks', 'true')
                successCallback(res.body)
            }
        })
}

function dealWithError(err: any, failedCall: SuperAgentRequest, successCallback: (body: any) => void, errorCallback: (err: any) => void, attempt: number, querySpecificNumbOfAttempts: number) {
    switch (err.status) {
        case undefined: // Server not responding
            if (attempt >= maxRetryAttempts) {
                sessionStorage.setItem('backendWorks', 'false')
                var event = document.createEvent("Event");
                event.initEvent("storage", true, true);
                window.dispatchEvent(event); //this is a workaround - storage change event won't fire without it.
            }
            setTimeout(function () {
                callWebApi(failedCall, successCallback, errorCallback, true, ++attempt, querySpecificNumbOfAttempts)
            }, retryBasePeriod * attempt)
            break
        case 400: // Bad request
        case 401: // Unauthorized
            errorCallback(decodeError(err))
            break
        default: // Unknown error response
            console.log(`WebApi unhandled error response: ${err.message} (${err.status})`)
            errorCallback(decodeError(err))
        // TODO: Deal with other errors
    }
}

function decodeError(err: any) {
    let message: string = ''
    if (err.response && err.response.body)
        message = err.response.body.Message
    else
        message = err.message

    return {
        code: err.status,
        message
    }
}

export function webApiGet(action: string, successCallback: (data: any) => void, errorCallback: (err: any) => void, query: object | string | null, querySpecificMaxNumbOfAttempts: number) {
    const call: SuperAgentRequest = request
        .get(WEBAPI_URL + action)
        .query(query ? query : '')
        .type('application/json; charset=utf-8')
        .set("Authorization", "Bearer " + LocalStorageWrapper.Get("id_token"))

    callWebApi(call, successCallback, errorCallback, true, 1, querySpecificMaxNumbOfAttempts)
}

export function webApiMultipartPost(action: string, data: any, successCallback: (body: any) => void, errorCallback: (err: any) => void) {
    const call = request
        .post(WEBAPI_URL + action)
        .attach('File', data)
        .set("Authorization", "Bearer " + LocalStorageWrapper.Get("id_token"))
    callWebApi(call, successCallback, errorCallback, true, 1, 1)
}

export function webApiPost(action: string, data: any, successCallback: (body: any) => void, errorCallback: (err: any) => void) {
    const call = request
        .post(WEBAPI_URL + action, data)
        .type('application/json; charset=utf-8')
        .set("Authorization", "Bearer " + LocalStorageWrapper.Get("id_token"))
    callWebApi(call, successCallback, errorCallback, true, 1, 1)
}

export function webApiPut(action: string, data: any, successCallback: (body: any) => void, errorCallback: (err: any) => void) {
    const call = request
        .put(WEBAPI_URL + action, data)
        .type('application/json; charset=utf-8')
        .set("Authorization", "Bearer " + LocalStorageWrapper.Get("id_token"))
    callWebApi(call, successCallback, errorCallback, true, 1, 1)
}

export function webApiDelete(action: string, data: any, successCallback: (body: any) => void, errorCallback: (err: any) => void) {
    const call = request
        .delete(WEBAPI_URL + action, data)
        .type('application/json; charset=utf-8')
        .set("Authorization", "Bearer " + LocalStorageWrapper.Get("id_token"))
    callWebApi(call, successCallback, errorCallback, true, 1, 1)
}